import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpInterceptor, HttpHeaders } from "@angular/common/http";
import { exhaustMap, take } from "rxjs/operators";
import { Helper } from 'src/app/shared/helper';
import { AuthService } from "src/app/shared/auth.service";
import { LanguageService } from "src/app/shared/language.service";


@Injectable()
export class ReqInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private helper: Helper, private languageService: LanguageService) { }

  httpHeaders!: HttpHeaders;

  intercept(req: HttpRequest<any>, next: HttpHandler): any {
    if (req.url.includes('nominatim.openstreetmap.org') || req.url.includes('photon.komoot.io')) {
      return next.handle(req);
    }

    return this.authService.loginSubject.pipe(
      take(1),
      exhaustMap((admin) => {
        const currentLanguageCode = localStorage.getItem("theme_lang");
        const currentLanguage = this.languageService.supportedLanguages.find((l: any) => l.code === currentLanguageCode);

        let adminToken: any = admin;

        if (!adminToken && localStorage.getItem("userToken")) {
          adminToken = localStorage.getItem("userToken");
        }

        if (!adminToken) {
          const jwtToken = this.helper.loginToken;
          if (jwtToken) {
            this.httpHeaders = new HttpHeaders().append("type", this.helper.EnitityType.user.toString()).append("Authorization", jwtToken.toString());
          } else {
            this.httpHeaders = new HttpHeaders().append("type", this.helper.EnitityType.user.toString());
          }
        } else {
          const jwtToken: any = this.helper.userToken ? this.helper.userToken : "";
          this.httpHeaders = new HttpHeaders().append("type", this.helper.EnitityType.user.toString()).append("Authorization", jwtToken.toString());
        }

        // Conditionally append language header
        if (currentLanguage) {
          this.httpHeaders = this.httpHeaders.append("language", currentLanguage.code);
        }

        const modifiedRequest: any = req.clone({
          headers: this.httpHeaders
        });

        return next.handle(modifiedRequest);
      })
    );
  }
}
